import Input from "../../../../input/Input";
import TextArea from "../../../../textarea/TextArea";
import PropTypes from "prop-types";
import DishOptionsCreator from "../dishOptions/DishOptionsCreator";
import './DishInfoCreator.scss';
import { getDishId } from "../../../../../../utils/model/dish";

const DishInfoCreator = ({dish, onDishChange}) => {
    const id = getDishId(dish);
    const {name, imageUrl, description, options} = dish;
    const handleDishChange = (value, name) => {
        onDishChange(id, name, value);
    }
    return (
        <div className="dish-info-creator">
            <div className="dish-info-creator__line">
                <Input
                    id={`dish-name-${id}`}
                    value={name}
                    onChange={handleDishChange}
                    placeholder="Name"
                    name="name"
                />
                <Input
                    id={`dish-image-url-${id}`}
                    value={imageUrl}
                    onChange={handleDishChange}
                    placeholder="Image URL"
                    name="imageUrl"
                />
            </div>
            <div className="dish-info-creator__line">
                <TextArea
                    id={`dish-description-${id}`}
                    name="description"
                    value={description}
                    onChange={handleDishChange}
                    placeholder="Description..."
                    label="Description"
                />
            </div>
            <div className="dish-info-creator__line">
                <DishOptionsCreator
                    id={id}
                    options={options}
                    onChange={handleDishChange}
                />
            </div>
        </div>
    );
}

DishInfoCreator.propTypes = {
    dish: PropTypes.object.isRequired,
    onDishChange: PropTypes.func.isRequired,
};

export default DishInfoCreator;
